import { API_BASE } from "@/lib/apiClient";
import { observeApiExchange, observeApiTransportError } from "@shared/serverReachability";

export const POST_LOGIN_HOME = "/";

export const ENTRA_LOGIN_ERRORS: Record<string, string> = {
  entra_auth_failed: "Anmeldung über Microsoft fehlgeschlagen.",
  entra_missing_code: "Antwort von Microsoft unvollständig. Bitte erneut versuchen.",
  entra_state_mismatch: "Sitzung ungültig. Bitte erneut anmelden.",
  entra_callback_failed: "Anmeldung konnte nicht abgeschlossen werden.",
};

export function isElectronLoginRuntime(): boolean {
  if (typeof window === "undefined") return false;
  return Boolean(
    window.envAPI?.isElectron === true &&
      typeof window.envAPI.openExternalLogin === "function",
  );
}

export function buildEntraStartUrl(postLoginPath = POST_LOGIN_HOME): string {
  const nextUrl = isElectronLoginRuntime()
    ? "camping-auth://callback"
    : `${window.location.origin}${postLoginPath.startsWith("/") ? postLoginPath : `/${postLoginPath}`}`;
  const apiBase = API_BASE || (typeof window !== "undefined" ? window.location.origin : "");
  return `${apiBase}/auth/entra/start?next=${encodeURIComponent(nextUrl)}`;
}

export function parseEntraLoginError(search: string): string | null {
  const error = new URLSearchParams(search).get("error");
  if (!error) return null;
  return ENTRA_LOGIN_ERRORS[error] ?? "Anmeldung fehlgeschlagen.";
}

export async function checkAuthenticated(): Promise<boolean> {
  if (!API_BASE) return false;
  try {
    const res = await fetch(`${API_BASE}/me`, {
      credentials: "include",
      cache: "no-store",
    });
    observeApiExchange(res.status);
    if (!res.ok) return false;
    const data = (await res.json().catch(() => ({}))) as { username?: string };
    return Boolean(data?.username);
  } catch (err) {
    observeApiTransportError(err);
    return false;
  }
}
